
import StoreService from './StoreService';

export { default } from './StoreService';
export const storeService = new StoreService();